import React from "react";

export function Label({ style, children, ...props }) {
  return (
    <label
      {...props}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px", // Tailwind gap-2
        fontSize: "14px", // text-sm
        lineHeight: 1, // leading-none
        fontWeight: 500, // font-medium
        userSelect: "none",
        cursor: props.disabled ? "not-allowed" : "default",
        opacity: props.disabled ? 0.5 : 1,
        ...style,
      }}
    >
      {children}
    </label>
  );
}
